import { Component } from '@angular/core';

@Component({
  selector: 'app-block-dnm',
  templateUrl: './block-dnm.component.html',
  styleUrls: ['./block-dnm.component.scss']
})
export class BlockDnmComponent {

}
